import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, orderBy, limit, startAfter, endBefore, onSnapshot, deleteField } from "firebase/firestore";
import { getStorage, ref, uploadBytes, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";
import { requestEndPoint } from '@/store/Api'

Vue.use(VueAxios, Axios);

const db = getFirestore();

const storageInstance = getStorage()
const storage = ref(storageInstance, "onDemandVideos/");
const storageImages = ref(storageInstance, "onDemandPreviewImages/");

export default {
    state: {
        loadingStatusOnDemand: 0,
        statusImageOnDemand: 0,
        onDemandList: [],
        onDemandCounterReproductor: {},
        unsubscribeOnDemandList: null,
        unsubscribeOnDemandCounterReproductor: null
    },
    mutations: {
        SET_VALUE_LOADING_STATUS_ON_DEMAND(state, value) {
            state.loadingStatusOnDemand = value
        },
        SET_VALUE_LOADING_IMAGE_ON_DEMAND(state, value) {
            state.statusImageOnDemand = value
        },
        SET_ON_DEMAND_LIST(state, onDemandList) {
            state.onDemandList = onDemandList;
        },
        SET_UNSUBSCRIBE_ON_DEMAND_LIST(state, unsubscribe) {
            state.unsubscribeOnDemandList = unsubscribe;
        },
        GO_UNSUBSCRIBE_ON_DEMAND_LIST(state) {
            state.unsubscribeOnDemandList();
        },
        SET_ON_DEMAND_COUNTER_REPRODUCTOR(state, counterReproductor) {
            state.onDemandCounterReproductor = counterReproductor;
        },
        SET_UNSUBSCRIBE_ON_DEMAND_COUNTER_REPRODUCTOR(state, unsubscribe) {
            state.unsubscribeOnDemandCounterReproductor = unsubscribe;
        },
        GO_UNSUBSCRIBE_ON_DEMAND_COUNTER_REPRODUCTOR(state) {
            state.unsubscribeOnDemandCounterReproductor();
        },
    },
    actions: {
        UploadVideoOnDemand({ commit }, onDemand) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `onDemandVideos/${random}`);
                    let bytes = new Blob([new Uint8Array(onDemand.principalVideo.blob)]);
                    console.log('storageRef', storageRef.name);
                    let metadata = {
                        contentType: 'video/mp4'
                    }
                    
                    // Upload the bytes
                    await uploadBytes(storageRef, bytes, metadata);
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UploadImagePreviewOnDemand({ commit }, onDemand) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `onDemandPreviewImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, onDemand.selectedImagePreview.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreateSetOnDemand({}, onDemand) {
            return new Promise(async(resolve, reject) => {
                delete onDemand.principalVideo.video
                delete onDemand.selectedImagePreview.img
                                 const newDocRef = doc(collection(db, "onDemandList"));
                 onDemand.id = newDocRef.id;
                 onDemand.createdAt = new Date()
                 onDemand.updatedAt = new Date()
                 await setDoc(newDocRef, onDemand)
                    .then(async(res) => {
                        await updateDoc(doc(db, "countersAnalytics", "onDemandReproductions"), {
                            [newOnDemand.id]: 0
                        })
                            .then((resCounter) => {
                                console.log('newOnDemand.id', newOnDemand.id);
                                resolve(newDocRef.id);
                            })
                            .catch((errCounter) => {
                                reject(errCounter);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        GetOnDemandList({ commit, getters }) {
            return new Promise(async(resolve, reject) => {
                getDocs(collection(db, "onDemandList")).then((querySnapshot) => {
                        let onDemandList = [];
                        querySnapshot.forEach((doc) => {
                            let onDemand = doc.data();
                            onDemand.counterReproductions = getters.getOnDemandCounterReproductor[onDemand.id] ? getters.getOnDemandCounterReproductor[onDemand.id] : 0
                            onDemandList.push(onDemand);
                        });
                        commit("SET_ON_DEMAND_LIST", onDemandList);
                        resolve(onDemandList);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        GetOnDemandPaginatedFirstPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                if (getters.getOnDemandList.length > 0) {
                    commit("GO_UNSUBSCRIBE_ON_DEMAND_LIST");
                }
                const q = query(collection(db, "onDemandList"), orderBy('name'), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let onDemandList = [];
                        querySnapshot.forEach((doc) => {
                            let onDemand = doc.data()
                            onDemandList.push(onDemand);
                        });
                        commit("SET_ON_DEMAND_LIST", onDemandList);
                        resolve(onDemandList);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_ON_DEMAND_LIST", unsubscribe);
            });
        },
        GetOnDemandNextPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_ON_DEMAND_LIST");
                const q = query(collection(db, "onDemandList"), orderBy('name'), startAfter(getters.getOnDemandList[getters.getOnDemandList.length - 1].name), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let onDemandList = [];
                        querySnapshot.forEach((doc) => {
                            let onDemand = doc.data()
                            onDemandList.push(onDemand);
                        });
                        console.log(onDemandList);
                        if (onDemandList.length > 0) {
                            commit("SET_ON_DEMAND_LIST", onDemandList);
                        }
                        resolve(onDemandList);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_ON_DEMAND_LIST", unsubscribe);
            });
        },
        GetOnDemandPrevPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_ON_DEMAND_LIST");
                const q = query(collection(db, "onDemandList"), orderBy('name', 'desc'), startAfter(getters.getOnDemandList[0].name), limit(itemsPerPage));
                let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let onDemandList = [];
                        querySnapshot.forEach((doc) => {
                            let onDemand = doc.data()
                            onDemandList.push(onDemand);
                        });
                        commit("SET_ON_DEMAND_LIST", onDemandList);
                        resolve(onDemandList);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_ON_DEMAND_LIST", unsubscribe);
            });
        },
        GetOnDemandCounterReproductor({ commit }) {
            return new Promise(async(resolve, reject) => {
                getDoc(doc(db, "countersAnalytics", "onDemandReproductions")).then((querySnapshot) => {
                        let counterReproductor = querySnapshot.data()
                        commit("SET_ON_DEMAND_COUNTER_REPRODUCTOR", counterReproductor);
                        resolve(counterReproductor);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        GoUnsuscribeGetOnDemandList({ commit }) {
            commit("GO_UNSUBSCRIBE_ON_DEMAND_LIST");
        },
        GoUnsuscribeGetOnDemandCounterReproductor({ commit }) {
            commit("GO_UNSUBSCRIBE_ON_DEMAND_COUNTER_REPRODUCTOR");
        },
        DeleteOnDemand({}, onDemand) {
            return new Promise(async(resolve, reject) => {
                let storageRef = ref(storageInstance, `onDemandVideos/${onDemand.principalVideo.ref}`);
                let storageRefImage = ref(storageInstance, `onDemandPreviewImages/${onDemand.selectedImagePreview.ref}`);

                await deleteObject(storageRefImage)
                    .then(async() => {
                        await deleteObject(storageRef)
                            .then(async() => {
                                await deleteDoc(doc(db, "onDemandList", onDemand.id))
                                    .then((res) => {
                                        updateDoc(doc(db, "countersAnalytics", "onDemandReproductions"), {
                                            [onDemand.id]: deleteField()
                                        })
                                        resolve(onDemand.id);
                                    })
                                    .catch((err) => {
                                        reject(err);
                                    });
                            }).catch((errorImg) => {
                                console.log('errorImg deleting storage', errorImg);
                                // Uh-oh, an error occurred!
                            });
                        // File deleted successfully
                    }).catch((error) => {
                        console.log('error deleting storage', error);
                        // Uh-oh, an error occurred!
                    });


            });
        },
        UpdateOnDemand({}, onDemand) {
            return new Promise(async(resolve, reject) => {
                if (onDemand.principalVideo.video) {
                    delete onDemand.principalVideo.video
                }
                if (onDemand.selectedImagePreview.img) {
                    delete onDemand.selectedImagePreview.img
                }
                if(onDemand.createdAt) {
                    delete onDemand.createdAt
                }
                onDemand.updatedAt = new Date()
                await updateDoc(doc(db, "onDemandList", onDemand.id), onDemand)
                    .then((res) => {
                        resolve(onDemand.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        RunQueryUpdateAllUsers({}) {
            return new Promise(async(resolve, reject) => {
                Vue.axios
                    .post(requestEndPoint.querieForSaveMetadata, {}, { accept: 'Application/json' })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            })
        }
    },
    getters: {
        getLoadingStatusOnDemand(state) {
            return state.loadingStatusOnDemand;
        },
        getLoadingImageOnDemand(state) {
            return state.statusImageOnDemand;
        },
        getOnDemandList(state) {
            return state.onDemandList;
        },
        getOnDemandCounterReproductor(state) {
            return state.onDemandCounterReproductor;
        }
    },
};